import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'
import { toColor } from 'utils'
import { Full as Loading } from 'components/Loading'

const Feedback = ({ feedback }) => {
  if (!feedback.length) {
    return (
      <div className="h-full w-full p-4 flex justify-center items-center text-gray-400 text-sm">
        <span>No feedback submitted, for selected team, in the last 30 days</span>
      </div>
    )
  }

  return (
    <ul className="h-full overflow-y-scroll divide-y divide-gray-200 bg-white shadow-inner">
      { feedback.map(({ id, note, nps, orderId, to }) => (
        <li key={`feedback-${id}`} className="relative bg-white py-5 px-4 hover:bg-gray-50 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary">
          <Link to={`/orders/${orderId}`}>
            <div className="flex justify-between space-x-3">
              <div className="min-w-0 flex-1">
                <a href="#" className="block focus:outline-none">
                  <span className="absolute inset-0" aria-hidden="true"></span>
                  <p className="text-sm font-medium text-gray-900 truncate space-x-1">
                    <span>Order</span>
                    <Link to={`/orders/${orderId}`} className="text-primary">#{ orderId }</Link>
                    <span>for { to.join(', ') }</span>
                  </p>
                </a>
              </div>
              <div className="shrink-0 whitespace-nowrap text-sm text-gray-500">
                { [...Array(11)].map((_, index) => (
                  <Icon
                    key={`star-${index}`}
                    icon="star"
                    className={index > nps ? `text-gray-300` : `text-yellow-400`}
                  />
                )) }
              </div>
            </div>
            <div className="mt-1">
              <p className="line-clamp-2 text-sm text-gray-600">
                { note }
              </p>
            </div>
          </Link>
        </li>
      )) }
    </ul>
  )
}

export default Feedback
